import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BasketControls from '../../containers/BasketControls';
import ColorBox from './ColorBox';

export default class BoughtDerivatives extends PureComponent {
  static propTypes = {
    basketItems: PropTypes.array.isRequired,
    productsBySku: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    parentSku: PropTypes.string,
    derivatives: PropTypes.object.isRequired,
  };

  getProductParamsFromIndexes = (indexes) => {
    const { dimensions } = this.props.derivatives;
    const derivativeDescription = [];
    let colour;
    indexes.forEach((index, dimension) => {
      const option = dimensions[dimension].options[index];
      derivativeDescription.push(option.value);
      if (option.colourCode) {
        colour = option.colourCode;
      }
    });
    return { title: derivativeDescription.join(' - '), colour };
  };

  findSkuInDerivativesTree = (sku, derivativesList) => {
    let path;
    const findSku = (derivatives, indexes = []) => {
      for (const el of derivatives) {
        if (el.sku && el.sku === sku) {
          indexes.push(el.index);
          path = indexes;
          break;
        } else if (el.children) {
          findSku(el.children, [...indexes, el.index]);
        }
      }
      return path;
    };
    findSku(derivativesList);
    return path;
  }

  render() {
    const { basketItems = [], productsBySku, router, parentSku, derivatives } = this.props;
    const { derivativesTree } = derivatives;

    const fellowDerivativesSku = basketItems
      .filter((el) => el.parentSku === parentSku)
      .map((el) => (el.sku));

    const fellowDerivativesFiltered =
      productsBySku ? Object.values(productsBySku).filter((el) => fellowDerivativesSku.includes(el.sku)) : [];

    const fellowDerivativesComponents = fellowDerivativesFiltered.map((derivative) => {
      const { sku } = derivative;
      const productParams = this.getProductParamsFromIndexes(this.findSkuInDerivativesTree(sku, derivativesTree));

      return (
        <div className="bop-derivativesQuantity__box" key={sku}>
          <div className="bop-derivativesQuantity__titleGroup">
            {productParams.colour && <ColorBox colourCode={`#${productParams.colour}`} />}
            <p className="bop-derivativesQuantity__title">
              {productParams.title}
            </p>
          </div>
          <BasketControls
            className="bop-derivativesQuantity"
            classNamePrefix="basketControlsDerivatives"
            basketItems={basketItems}
            product={derivative}
            sku={sku}
            router={router}
            showClearButton
            hasDerivatives
          />
        </div>
      );
    });
    return !!fellowDerivativesFiltered.length && (
      <div className="bop-derivativesBoxWrapper">
        {fellowDerivativesComponents}
      </div>);
  }
}
